module.exports = {
  "country": "CZ",
  "artist": "Aiko",
  "song": "Pedestal",
  "year": "2024",
  "place": "NQ",
  "spotify": "0XzSKAgVOdtMSfzYY0qtAb"
};